import { Injectable } from '@angular/core';
import { AddToWatchlistConfirmationDialogComponent } from 'src/app/shared/dialogs/add-to-watchlist-confirmation-dialog/add-to-watchlist-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteFromWatchlistConfirmationDialogComponent } from 'src/app/shared/dialogs/delete-from-watchlist-confirmation-dialog/delete-from-watchlist-confirmation-dialog.component';
import { AddToPortafoglioConfirmationDialogComponent } from 'src/app/shared/dialogs/add-to-portafoglio-confirmation-dialog/add-to-portafoglio-confirmation-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteNotificationConfirmationDialogComponent } from 'src/app/shared/dialogs/delete-notification-confirmation-dialog/delete-notification-confirmation-dialog.component';
import { AddNewProductModalComponent } from '../../shared/dialogs/add-new-product-modal/add-new-product-modal.component';
import { DeleteProductConfirmationDialogComponent } from '../../shared/dialogs/delete-product-confirmation-dialog/delete-product-confirmation-dialog.component';
import { DeleteCreditiConfirmationDialogComponentComponent } from '../../shared/dialogs/delete-crediti-confirmation-dialog-component/delete-crediti-confirmation-dialog-component.component';
import { EventDetailsModalComponent } from 'src/app/shared/dialogs/event-details-modal/event-details-modal.component';
import { CalendarEvent } from 'angular-calendar';
import { DeleteEventConfirmationDialogComponent } from 'src/app/features/gestione-eventi/delete-event-confirmation-dialog/delete-event-confirmation-dialog.component';
import { AddNewWatchlistDialogComponent } from 'src/app/shared/dialogs/add-new-watchlist-dialog/add-new-watchlist-dialog.component';
import { SaveAnalisiScenarioDialogComponent } from 'src/app/shared/dialogs/save-analisi-scenario-dialog/save-analisi-scenario-dialog.component';
import { SaveSearchDialogComponent } from 'src/app/features/advanced-search/save-search-dialog/save-search-dialog.component';
import { DeleteSearchDialogComponent } from 'src/app/features/advanced-search/delete-search-dialog/delete-search-dialog.component';
import { UpdatePortfolioIsinDialogComponent } from 'src/app/shared/dialogs/update-portfolio-isin-dialog/update-portfolio-isin-dialog.component';
import { IsinDataDialogModel } from 'src/app/models/dialogs-models/isin-data-dialog-model';
import { SubscriptionsDialogComponent } from 'src/app/features/gestione-utenti/subscriptions-dialog/subscriptions-dialog.component';
import { EmailBoxDialogComponent } from 'src/app/features/gestione-utenti/email-box-dialog/email-box-dialog.component';
import { ResetPasswordDialogComponent } from 'src/app/features/gestione-utenti/reset-password-dialog/reset-password-dialog.component';
import { InfoModalComponent } from 'src/app/shared/info-modal/info-modal.component';
import { TableInfo } from 'src/app/models/tableInfo';
import { PrivacyModalComponent } from 'src/app/features/privacy-modal/privacy-modal.component';
import { DeleteSubscriptionConfirmationDialogComponent } from 'src/app/shared/dialogs/delete-subscription-confirmation-dialog/delete-subscription-confirmation-dialog.component';
import { ConfirmUpdateSearchTableComponent } from 'src/app/shared/dialogs/confirm-update-search-table/confirm-update-search-table.component';
import {ConfirmUpdateVariazioneSottostanteAppoTableComponent} from '../../shared/dialogs/confirm-update-variazione-sottostante-appo-table/confirm-update-variazione-sottostante-appo-table.component';
import { RenameComponent } from 'src/app/shared/dialogs/rename-portfolio/rename.component';
import { RenameModel } from 'src/app/models/renameModel';
import { DeleteCertificateConfirmationDialogComponent } from 'src/app/shared/dialogs/delete-certificate-confirmation-dialog/delete-certificate-confirmation-dialog.component';
import { DeletePortfolioConfirmationDialogComponent } from 'src/app/shared/dialogs/delete-portfolio-confirmation-dialog/delete-portfolio-confirmation-dialog.component';
import {AlertDialogComponent, AlertDialogData} from '../../shared/dialogs/alert-dialog/alert-dialog.component';
import {TermsDialogComponent} from '../../shared/dialogs/terms-dialog/terms-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  public openTableInfoDialog(tableInfo: TableInfo) {
    const dialogRef = this.dialog.open(InfoModalComponent, {
      data: tableInfo
    });

    return dialogRef.afterClosed();
  }

  public openPrivacyDialog() {
    const dialogRef = this.dialog.open(PrivacyModalComponent);

    return dialogRef.afterClosed();
  }

  openSaveAnalisiScenarioDialog() {
    const dialogRef = this.dialog.open(SaveAnalisiScenarioDialogComponent, {
      width: '250px'
    });

    return dialogRef.afterClosed();
  }

  openAddNewWatchlistDialog() {
    const dialogRef = this.dialog.open(AddNewWatchlistDialogComponent, {
      width: '250px'
    });

    return dialogRef.afterClosed();
  }


  openAddToPortafoglioDialog(isPortafoglio: boolean) {
    const dialogRef = this.dialog.open(AddToPortafoglioConfirmationDialogComponent, {
      width: '250px',
      data: isPortafoglio
    });
    return dialogRef.afterClosed();
  }


  openAddToWatchlistDialog() {
    const dialogRef = this.dialog.open(AddToWatchlistConfirmationDialogComponent, {
      width: '250px'
    });

    return dialogRef.afterClosed();
  }

  openUpdateIsinInPortfolioDialog(isinData: IsinDataDialogModel) {
    const dialogRef = this.dialog.open(UpdatePortfolioIsinDialogComponent, {
      width: '250px',
      data: isinData
    });

    return dialogRef.afterClosed();
  }

  public openSubscriptionsDialog(dialogData: any) {
    const dialogRef = this.dialog.open(SubscriptionsDialogComponent, {
      width: '1000px',
      data: dialogData
    });

    return dialogRef.afterClosed();
  }
  public openEmailBoxDialog(userData: { username: string, email: string }) {
    const dialogRef = this.dialog.open(EmailBoxDialogComponent, {
      width: '800px',
      data: userData
    });

    return dialogRef.afterClosed();
  }
  public openResetPasswordDialog(username: string) {
    const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
      width: '600px',
      data: username
    });

    return dialogRef.afterClosed();
  }

  openSuccessSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 4000,
      verticalPosition: 'bottom',
      panelClass: ['success-snackbar'],
    });
  }

  openFailureSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 4000,
      verticalPosition: 'bottom',
      panelClass: ['failure-snackbar'],
    });
  }

  openWarningSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 4000,
      verticalPosition: 'bottom',
      panelClass: ['warning-snackbar'],
    });
  }


  openDeleteFromWatchlistConfirmDialog(watchlist: any) {
    const dialogRef = this.dialog.open(DeleteFromWatchlistConfirmationDialogComponent, {
      width: '250px',
      data: watchlist.isin
    });

    return dialogRef.afterClosed();
  }

  openDeleteFromPortafoglioConfirmDialog(portafoglio: any) {
    const dialogRef = this.dialog.open(DeleteFromWatchlistConfirmationDialogComponent, {
      width: '250px',
      data: portafoglio.isin
    });

    return dialogRef.afterClosed();
  }

  openDeleteNotificationConfirmDialog(notificationId?: number) {
    const dialogRef = this.dialog.open(DeleteNotificationConfirmationDialogComponent, {
      width: '250px',
      data: notificationId
    });

    return dialogRef.afterClosed();
  }

  openAddNewProductDialog(id?: number) {
    const dialogRef = this.dialog.open(AddNewProductModalComponent, {
      width: '500px',
      data: id
    });

    return dialogRef.afterClosed();
  }

  openDeleteProductConfirmDialog(nomeProdotto?: string) {
    const dialogRef = this.dialog.open(DeleteProductConfirmationDialogComponent, {
      width: '400px',
      data: nomeProdotto
    });

    return dialogRef.afterClosed();
  }

  openDeleteCreditiConfirmDialog() {
    const dialogRef = this.dialog.open(DeleteCreditiConfirmationDialogComponentComponent, {
      width: '450px',
    });

    return dialogRef.afterClosed();
  }

  openDeleteSavedSearchConfirmDialog(searchName: string) {
    const dialogRef = this.dialog.open(DeleteSearchDialogComponent, {
      width: '450px',
      data: searchName
    });

    return dialogRef.afterClosed();
  }

  openSaveSearchDialog() {
    const dialogRef = this.dialog.open(SaveSearchDialogComponent, {
      width: '450px'
    });

    return dialogRef.afterClosed();
  }

  openEventDetails(event: CalendarEvent<{ description: string }>): void {
    this.dialog.open(EventDetailsModalComponent, {
      data: event
    });
  }

  openDeleteEventConfirmationDialog() {
    const dialogRef = this.dialog.open(DeleteEventConfirmationDialogComponent, {
      width: '450px'
    });
    return dialogRef.afterClosed();
  }

  openDeleteSubscriptionConfirmationDialog(subscriptionName: string) {
    const dialogRef = this.dialog.open(DeleteSubscriptionConfirmationDialogComponent, {
      width: '450px',
      data: subscriptionName
    });
    return dialogRef.afterClosed();
  }

  openConfirmUpdateSearchTable() {
    const dialogRef = this.dialog.open(ConfirmUpdateSearchTableComponent, {
      width: '450px'
    });
    return dialogRef.afterClosed();
  }

  openConfirmUpdateVariazioneSottostanteAppoTable() {
    const dialogRef = this.dialog.open(ConfirmUpdateVariazioneSottostanteAppoTableComponent, {
      width: '450px'
    });
    return dialogRef.afterClosed();
  }

  openRename(rename: RenameModel ) {
    const dialogRef = this.dialog.open(RenameComponent, {
      data : rename
    });
    return dialogRef.afterClosed();
  }

  openConfirmDeleteCertificate(certificateName: string) {
    const dialogRef = this.dialog.open(DeleteCertificateConfirmationDialogComponent, {
      data : certificateName
    });
    return dialogRef.afterClosed();
  }

  openConfirmDeletePortfolio(portfolioName: string) {
    const dialogRef = this.dialog.open(DeletePortfolioConfirmationDialogComponent, {
      data: portfolioName
    });
    return dialogRef.afterClosed();
  }

  openAlertDialog(alertDialogData: AlertDialogData, config: any = {}) {
    const dialogRef = this.dialog.open(
      AlertDialogComponent,
      {
        data: alertDialogData,
        ...config
      });
    return dialogRef.afterClosed();
  }

  openTermsDialog() {
    const dialogRef = this.dialog.open(TermsDialogComponent);
    return dialogRef.afterClosed();
  }
}
